import { Link } from 'react-router'
import styles from '../rows.module.css'

export interface PersonProps {
  name: string
  /** Already resolved to a servable path by the server; never built here. */
  portraitUrl?: string | null | undefined
  /** All-caps line under the name — owner, role, type. */
  meta?: string | null | undefined
  /** A character id turns the row into a link to that sheet. */
  characterId?: number | undefined
}

/**
 * A portrait and a name.
 *
 * Written for the campaign screens and now shared by every surface that lists people:
 * participants, a campaign roster, a faction's members, a place's cast, the city's Faces,
 * a case's major characters, a scene's cast, an encounter's sides. It moved out of the
 * campaign domain the moment the second domain wanted it.
 *
 * Portraits arrive as relative `/fileserver/...` paths, which the Vite proxy serves from
 * the API host in dev, so `src` needs no rewriting. A missing one falls back to an initial
 * rather than a broken image or a blank square.
 */
export function Person({ name, portraitUrl, meta, characterId }: PersonProps) {
  const body = (
    <>
      {portraitUrl !== null && portraitUrl !== undefined && portraitUrl !== '' ? (
        <img className={styles.avatar} src={portraitUrl} alt="" loading="lazy" />
      ) : (
        <span className={styles.avatarFallback} aria-hidden="true">
          {name.slice(0, 1).toUpperCase()}
        </span>
      )}
      <span className={styles.personText}>
        <span className={styles.rowName}>{name}</span>
        {meta !== null && meta !== undefined && meta !== '' && (
          <span className={styles.rowMeta}>{meta}</span>
        )}
      </span>
    </>
  )

  if (characterId === undefined) {
    return <span className={styles.person}>{body}</span>
  }

  return (
    <Link to={`/characters/${characterId}`} className={styles.person}>
      {body}
    </Link>
  )
}
